import React, { useState, useEffect } from "react";
import styles from './PokemonListPage.module.css';
import placeHolder from '../../assets/13.png';
import { getPokemons } from "../../services/services";
import { Col, Row } from "antd";

export default function PokemonListPage() {

    useEffect(() => {
        listPokemons()
    }, [])

    const [pokemon, setPokemon] = useState<any>()

    const listPokemons = async () => {
        const response = await getPokemons();
        setPokemon(response)
    }
    return (
        <>
                <Row >

                {pokemon?.map((item: any) =>
                
                <>
                <Col xs={12}>
                    <div className={styles['container']}>
                    <div className={styles['container-image']} >
                        <div className={styles['image-container']}>
                            <img src={`data:image/png;base64,${item.spriteBase64}`} className={styles['image']} alt='Pokemon' />
                        </div>
                        <div className={styles['text-container']}>
                            <h1>Nome: {item.name}</h1>
                            <h1>Gênero: {item.gender}</h1>
                            <h1>Tipo: {item.types}</h1>
                        </div>
                    </div>
                </div>
                </Col>
                </>
                )}
                </Row>
        </>
    )
}
